import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=174b6ca4&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=174b6ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174b6ca4",
  null
  
)

export default component.exports